/** @type {import('Simple/types.js').useDataOnSubmit} */
import { useMutation } from 'Data/Api.js'
import { useDataValue } from 'Simple/Data.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'
import mutation from './mutation.graphql.js'

export default function useDataOnSubmit(props, data) {
  let location_id = useDataValue({
    context: 'global',
    path: 'current_location._id',
    viewPath: props.viewPath,
  })

  let [, executeMutation] = useMutation(mutation)
  let [, notify] = useNotifications()

  return async function onSubmit({ value, originalValue, args, change }) {
    if (value.current_index < value.steps.length - 1) {
      change(next => {
        next.current_index += 1
      })
      return
    }

    let mutationResponse = await executeMutation({
      id: props.launcher.id,
      resource_id: props.resourceId,
      location_id,
      local: Object.fromEntries(
        value.steps.map(item => [item.key, item.value])
      ),
    })

    if (mutationResponse.error) {
      return notify(notifyError(`There was a problem launching the app.`))
    }

    if (!mutationResponse.data.apps_launchers_resolve.ok) {
      return notify(
        notifyError(mutationResponse.data.apps_launchers_resolve.message)
      )
    }

    if (typeof props.onClose === 'function') {
      props.onClose()
    }

    if (typeof props.onLauncherResolved === 'function') {
      props.onLauncherResolved({
        launcher: props.launcher,
        response: mutationResponse.data.apps_launchers_resolve,
      })
    } else {
      if (mutationResponse.data.apps_launchers_resolve.message) {
        return notify(
          notifySuccess(mutationResponse.data.apps_launchers_resolve.message)
        )
      }
    }
  }
}
